<template>
    <div class="ph-page">
        <div class="ph-header">
            <div class="ph-header-left">
                <div class="ph-icon-wrap"><i class="fas fa-file-invoice-dollar"></i></div>
                <h2 class="ph-title">Payroll Payments</h2>
                <span class="ph-count" v-if="items.length">{{ items.length }}</span>
            </div>
        </div>

        <div v-if="loading" class="ph-loading"><div class="ph-spinner"></div><span>Loading...</span></div>
        <div v-else-if="!items.length" class="ph-empty">
            <div class="ph-empty-icon"><i class="fas fa-file-invoice-dollar"></i></div>
            <h3>No payroll payments found</h3>
        </div>
        <div v-else class="ph-grid">
            <div class="ph-card" v-for="(item, idx) in items" :key="item.id" :style="{ animationDelay: `${idx * 0.03}s` }">
                <div class="ph-card-top">
                    <div class="ph-card-icon" :class="phColor(idx)"><i class="fas fa-file-invoice-dollar"></i></div>
                    <div class="ph-card-info">
                        <h4 class="ph-card-name">{{ item.companyName || 'Payroll' }}</h4>
                        <span class="ph-card-date" v-if="item.createdAt">
                            <i class="fas fa-clock"></i> {{ formatDate(item.createdAt) }}
                        </span>
                    </div>
                </div>
                <div class="ph-card-details">
                    <div class="ph-detail" v-if="item.startDate">
                        <span class="ph-detail-label">From</span>
                        <span class="ph-detail-val">{{ item.startDate }}</span>
                    </div>
                    <div class="ph-detail" v-if="item.endDate">
                        <span class="ph-detail-label">To</span>
                        <span class="ph-detail-val">{{ item.endDate }}</span>
                    </div>
                    <div class="ph-detail" v-if="item.year">
                        <span class="ph-detail-label">Year</span>
                        <span class="ph-detail-val">{{ item.year }}</span>
                    </div>
                </div>
                <div class="ph-card-actions">
                    <a class="ph-action-btn ph-btn-view" :href="$router.resolve({ name: 'payroll_history_detail', params: { id: item.id } }).href">
                        <i class="fas fa-eye"></i> View Details
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { http } from "@/utils/http"
import { PERMISSION_CODES } from "../../store/permission"

export default {
    data() {
        return { loading: true, PERMISSION_CODES, items: [] }
    },
    async mounted() { await this.fetchData(); this.loading = false },
    methods: {
        phColor(i) { return ["ph-clr-blue","ph-clr-purple","ph-clr-teal","ph-clr-amber","ph-clr-rose"][i % 5] },
        formatDate(d) {
            if (!d) return ''
            // Try native Date parse first
            const native = new Date(d)
            if (!isNaN(native.getTime())) {
                return native.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
            }
            // Handle custom format like "17/00/2024 - 12:16 PM"
            const m = String(d).match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/)
            if (m) {
                const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
                const day = m[1].padStart(2, '0')
                const monIdx = parseInt(m[2], 10) - 1
                const mon = months[monIdx] || '??'
                return `${day} ${mon} ${m[3]}`
            }
            return d
        },
        async fetchData() {
            try { const r = await http.get("/payroll-payments"); this.items = r.data.result || r.data || [] } catch(e) { console.log(e) }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";
.ph-page { animation: phFade .3s ease; }
@keyframes phFade { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }
.ph-header { display:flex; align-items:center; justify-content:space-between; gap:12px; background:white; border:1px solid $gray100; border-radius:8px; padding:10px 16px; margin-bottom:12px; box-shadow:$shadowSm; flex-wrap:wrap; }
.ph-header-left { display:flex; align-items:center; gap:10px; }
.ph-icon-wrap { width:32px; height:32px; border-radius:8px; background:linear-gradient(135deg,$primaryLight,darken($primaryLight,4%)); color:$primaryColor; display:flex; align-items:center; justify-content:center; font-size:14px; }
.ph-title { font-size:15px; font-weight:700; color:$gray800; margin:0; }
.ph-count { min-width:20px; height:20px; padding:0 6px; border-radius:$radiusFull; font-size:11px; font-weight:700; background:$primaryColor; color:white; display:inline-flex; align-items:center; justify-content:center; }
.ph-loading { display:flex; align-items:center; justify-content:center; gap:10px; padding:64px 16px; background:white; border:1px solid $gray100; border-radius:8px; box-shadow:$shadowSm; span { font-size:13px; color:$gray400; } }
.ph-spinner { width:24px; height:24px; border:2.5px solid $gray200; border-top-color:$primaryColor; border-radius:50%; animation:phSpin .7s linear infinite; }
@keyframes phSpin { to { transform:rotate(360deg); } }
.ph-empty { text-align:center; padding:64px 16px; background:white; border:1px solid $gray100; border-radius:8px; box-shadow:$shadowSm; h3 { font-size:14px; font-weight:700; color:$gray600; margin:0; } }
.ph-empty-icon { width:48px; height:48px; border-radius:$radiusFull; background:$gray50; border:1px solid $gray100; display:flex; align-items:center; justify-content:center; margin:0 auto 12px; i { font-size:20px; color:$gray300; } }
.ph-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:10px; }
.ph-card { background:white; border:1px solid $gray100; border-radius:10px; padding:14px; box-shadow:$shadowSm; display:flex; flex-direction:column; gap:10px; animation:phSlide .25s ease both; transition:all $transitionFast; &:hover { border-color:$gray200; box-shadow:$shadowMd; transform:translateY(-1px); } }
@keyframes phSlide { from { opacity:0; transform:translateY(4px); } to { opacity:1; transform:translateY(0); } }
.ph-card-top { display:flex; align-items:flex-start; gap:10px; }
.ph-card-icon { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:14px; flex-shrink:0; }
.ph-clr-blue { background:#eff6ff; color:#2563eb; }
.ph-clr-purple { background:#f5f3ff; color:#7c3aed; }
.ph-clr-teal { background:#f0fdfa; color:#0d9488; }
.ph-clr-amber { background:#fffbeb; color:#d97706; }
.ph-clr-rose { background:#fff1f2; color:#e11d48; }
.ph-card-info { flex:1; min-width:0; }
.ph-card-name { font-size:13.5px; font-weight:700; color:$gray800; margin:0 0 3px; line-height:1.3; }
.ph-card-date { font-size:11px; color:$gray400; font-weight:500; display:inline-flex; align-items:center; gap:4px; i { font-size:10px; } }
.ph-card-details { display:flex; flex-wrap:wrap; gap:6px; }
.ph-detail { flex:1; min-width:70px; background:$gray50; border:1px solid $gray100; border-radius:6px; padding:6px 10px; display:flex; flex-direction:column; gap:2px; }
.ph-detail-label { font-size:10px; color:$gray400; font-weight:500; text-transform:uppercase; letter-spacing:0.3px; }
.ph-detail-val { font-size:12px; color:$gray700; font-weight:600; }
.ph-card-actions { display:flex; gap:6px; margin-top:auto; padding-top:6px; border-top:1px solid $gray100; }
.ph-action-btn { display:inline-flex; align-items:center; gap:4px; padding:4px 10px; border:1px solid $gray200; border-radius:5px; font-size:11px; font-weight:600; cursor:pointer; transition:all $transitionFast; font-family:inherit; background:white; text-decoration:none; i { font-size:10px; } }
.ph-btn-view { color:$primaryColor; &:hover { background:$primaryLight; border-color:rgba(0,94,137,0.15); } }
@media(max-width:992px) { .ph-grid { grid-template-columns:repeat(2,1fr); } }
@media(max-width:480px) { .ph-grid { grid-template-columns:1fr; } }
</style>
